import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { var_api } from "../../../constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ReasonMaster = () => {
  const tableHeaders = ["#", "Reason Type",  "Action"];

  const [reasonData, setReasonData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const warehouse_id = localStorage.getItem("warehouse_id");

  const [formData, setFormData] = useState({
    id: null,
    reason_name: "",
    warehouse_id: warehouse_id,
  });

  const [errors, setErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchReasonData();
  }, []);

  const fetchReasonData = async () => {
    try {
      const res = await axios.get(`${var_api}sa-veemart-reason-master/get-by-warehouse/${warehouse_id}`);
      setReasonData(res.data || []);
    } catch {
      toast.error("Failed to fetch data");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleAddClick = () => {
    setFormData({
      id: null,
      reason_name: "",
      warehouse_id: warehouse_id,
    });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({
      id: item.id,
      reason_name: item.reason_name,
      warehouse_id: warehouse_id,
    });
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.reason_name.trim())
      newErrors.reason_name = "Reason name is required";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.warning("Fix the highlighted fields");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        reason_name: formData.reason_name,
        warehouse_id: warehouse_id,
      };

      let res;
      if (isEditMode) {
        res = await axios.put(
          `${var_api}sa-veemart-reason-master/update/${formData.id}`,
          payload
        );
      } else {
        res = await axios.post(
          `${var_api}sa-veemart-reason-master/post`,
          payload
        );
      }

      toast.success(res?.data?.message || "Saved successfully!");
      setShowModal(false);
      fetchReasonData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save");
    } finally {
      setLoading(false);
    }
  };

  // SEARCH + PAGINATION
  const filteredData = reasonData.filter((item) =>
    item.reason_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-end mb-3 gap-2">
            <input
              type="text"
              className="form-control w-auto"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
            />
            <Button variant="secondary" onClick={handleAddClick}>
              Add
            </Button>
          </div>

          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  {tableHeaders.map((header, idx) => (
                    <th key={idx}>{header}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {paginatedData.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center text-muted py-3">
                      No data found
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((item, idx) => (
                    <tr key={item.id}>
                      <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                      <td>{item.reason_name}</td>
                      {/* <td>{warehouse_id}</td> */}

                      <td>
                        <Link
                          to="#"
                          className="btn shadow btn-xs sharp me-1"
                          style={{
                            backgroundColor: "#007bff",
                            color: "white",
                          }}
                          onClick={() => handleEditClick(item)}
                        >
                          <i className="fas fa-pencil-alt"></i>
                        </Link>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            <div className="d-flex justify-content-end mt-3">
              {[...Array(totalPages)].map((_, idx) => (
                <Button
                  key={idx}
                  variant={currentPage === idx + 1 ? "primary" : "light"}
                  onClick={() => setCurrentPage(idx + 1)}
                  className="me-1"
                >
                  {idx + 1}
                </Button>
              ))}
            </div>
          </div>
        </Card.Body>

        {/* MODAL */}
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="md"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isEditMode ? "Edit Reason" : "Add Reason"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Reason Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="reason_name"
                      placeholder="Enter reason"
                      value={formData.reason_name}
                      onChange={handleInputChange}
                    />
                    {errors.reason_name && (
                      <div className="text-danger small mt-1">
                        {errors.reason_name}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

                      <div className="d-flex justify-content-end gap-2">
  {!isEditMode ? (
    <>
      <Button variant="secondary" type="submit" disabled={loading}>
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Creating...
          </>
        ) : (
          "Create"
        )}
      </Button>
      <Button
        variant="danger"
        type="reset"
        disabled={loading}
      onClick={() =>
  setFormData({
    id: null,
    reason_name: "",
    warehouse_id: warehouse_id,
  })
}

      >
        Reset
      </Button>
    </>
  ) : (
    <>
      <Button variant="warning" type="submit" disabled={loading}>
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Updating...
          </>
        ) : (
          "Update"
        )}
      </Button>
      <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
        Cancel
      </Button>
    </>
  )}
</div>
            </Form>
          </Modal.Body>
        </Modal>
      </Card>

      <ToastContainer />
    </>
  );
};

export default ReasonMaster;
